/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from 'react';
import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
import Divider from '@mui/joy/Divider';
import FormControl from '@mui/joy/FormControl';
import Link from '@mui/joy/Link';
// import Grid from '@mui/material/Grid';
import Input from '@mui/joy/Input';
import Table from '@mui/joy/Table';
import Sheet from '@mui/joy/Sheet';
import IconButton, { iconButtonClasses } from '@mui/joy/IconButton';
import Typography from '@mui/joy/Typography';
import Option from '@mui/joy/Option';
import { Modal } from '@mui/joy';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import SearchIcon from '@mui/icons-material/Search';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import CircularProgress from '@mui/joy/CircularProgress';
import { ZoomIn } from '@mui/icons-material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { branches } from '../config';
import FormLabel from '@mui/joy/FormLabel';
import Select from '@mui/joy/Select';
// import Card from '@mui/joy/Card';

import axios from 'axios';

type PoForm  = {
  part: string;
  qty: number;
  branch: string;
};

type RelatedUnit = {
  id: number;
  model: string;
  description: string;
};

interface Part {
  id: number;
  number: string;
  number_new: string;
  name_eng: string;
  description: string;
  price_list: number;
  active: boolean;
  pic: string;
}

interface PagedResult<T> {
  records: T[];
  total: number;
  size: number;
  current: number;
  pages: number;
}

interface BarcodeResponse<T> {
  code: number;
  msg: string;
  data: PagedResult<T>;
}

// function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
//   if (b[orderBy] < a[orderBy]) {
//     return -1;
//   }
//   if (b[orderBy] > a[orderBy]) {
//     return 1;
//   }
//   return 0;
// }

type Order = 'asc' | 'desc';

// function getComparator<Key extends keyof any>(
//   order: Order,
//   orderBy: Key,
// ): (
//   a: { [key in Key]: number | string },
//   b: { [key in Key]: number | string },
// ) => number {
//   return order === 'desc'
//     ? (a, b) => descendingComparator(a, b, orderBy)
//     : (a, b) => -descendingComparator(a, b, orderBy);
// }

export default function PartTable() {
  const [parts, setParts] = useState<Part[]>([]);
  const [nextPage, setNextPage] = useState<string | null>(null);
  const [prevPage, setPrevPage] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [totalPages, setTotalPages] = useState<number>(0);  // Added state for total pages
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [imageOpen, setImageOpen] = useState(false);
  const [imageSrc, setImageSrc] = useState<string | undefined>('');
  const [orderOpen, setOrderOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [currentPart, setCurrentPart] = useState('');
  const [relatedUnits, setRelatedUnits] = useState<RelatedUnit[]>([]);
  const [relatedUnitFilter, setRelatedUnitFilter] = useState('');
  // const apiUrl = 'https://sks.atosausa.com/api/';  // legacy API (PO, etc.)
  // const apiUrl = 'https://sksparts.atosausa.com/api/';  // this url is for sksparts domain only
  // Use absolute barcode API URL so production does not depend on a dev proxy
  const barcodeApiUrl = 'https://barcode.atosausa.com/api';

  const fetchParts = async (searchTerm: string = '', page: number = 1) => {
    setLoading(true);
    try {
      const response = await axios.get<BarcodeResponse<any>>(`${barcodeApiUrl}/parts`, {
        params: {
          pageNum: page,
          pageSize: 200,
          // Use generic keyword search so backend can match by
          // part number, name, etc.
          keyword: searchTerm || undefined,
        },
      });

      const paged = response.data.data;
      const mappedParts: Part[] = paged.records.map((p: any) => {
        return {
          id: p.id,
          number: p.number,
          number_new: p.numberNew,
          name_eng: p.nameEng,
          description: p.description || '',
          price_list: p.priceList ?? 0,
          active: p.active,
          pic: p.pic || '',
        };
      });

      setParts(mappedParts);
      setNextPage(paged.current < paged.pages ? String(paged.current + 1) : null);
      setPrevPage(paged.current > 1 ? String(paged.current - 1) : null);
      const total = paged.total;
      const pages = Math.ceil(total / 200);
      setTotalPages(pages);

    } catch (error) {
      console.error('Error fetching parts:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchParts(searchTerm, currentPage);
  }, [searchTerm, currentPage]);

  const handlePagination = (page: number) => {
    setCurrentPage(page);
  };

  const handleSearch = (query: string) => {
    setSearchTerm(query);
    setCurrentPage(1);
    // Add your search logic here, e.g., API calls or filtering
  };

  const handleClickOpen = (pic: string | null) => {
    if (pic) {
      setImageSrc(pic);
      setImageOpen(true);
    }
  };

  // const handleOrderClick = (row:any) => {
  //   setCurrentPart(row.number);
  //   setPoForm((prevForm) => ({
  //     ...prevForm,
  //     part: row.id,
  //   }));
  //   setOrderOpen(true);
  // };

  

  const handleEditClose = () => {
    setEditOpen(false);
    setEditLoading(false);
  };

  const handleClose = () => {
    setImageOpen(false);
    setImageSrc('');
  };

  const handleOrderClose = () => {
    setOrderOpen(false);
  }

  const getPaginationRange = () => {
    const range: number[] = [];
    const start = Math.max(1, currentPage - 2);
    const end = Math.min(totalPages, currentPage + 2);

    for (let i = start; i <= end; i++) {
      range.push(i);
    }

    return range;
  };
  const [order, setOrder] = React.useState<Order>('desc');
  // const [selected, setSelected] = React.useState<readonly string[]>([]);
  // const [open, setOpen] = React.useState(false);

  const [poForm, setPoForm] = useState<PoForm>({
    part: '',
    qty: 5,
    branch: '',
  });

  const csrfToken = document.cookie
    .split('; ')
    .find(row => row.startsWith('XSRF-TOKEN'))
    ?.split('=')[1];

  const handleSubmit = () => {
    const uri = 'https://sks.atosausa.com/api/po/'; // when deploy to sks.atosausa.com, use this url
    // const uri = 'https://sksparts.atosausa.com/api/po/'; //
    const body = poForm;
    fetch(uri, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(csrfToken && { 'X-CSRFToken': csrfToken }),
      },
      body: JSON.stringify(body),
    })
      .then(async (response) => {
        if (response.status === 403) {
          // Show the exact error message as requested
          alert('Authentication credentials were not provided.');
          throw new Error('Authentication credentials were not provided.');
        }
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(() => {
        alert('Order submitted successfully!');
        handleOrderClose();
      })
      .catch((error) => {
        console.error('Error:', error);
        if (error.message.includes('Authentication credentials were not provided')) {
          // Already alerted above
        } else {
          alert('Failed to submit order. Please try again.');
        }
      });
  };

  const handleChange = (v:any) => {
    //const { name, value } = e.target;
    setPoForm((prevForm) => ({
      ...prevForm,
      branch: v,
    }));
  };

  
  const handleEditClick = (row:any) => {
    // Show loading screen
    setEditLoading(true);
    setCurrentPart(row.number);

    const loadEditData = async () => {
      try {
        // Get units that currently use this part from barcode API
        const response = await axios.get(`${barcodeApiUrl}/part-units/u/${row.id}`);
        const results = response.data.results || [];
        const mapped: RelatedUnit[] = results
          .filter((u: any) => u.country === 'USA')
          .map((u: any) => ({
            id: u.id,
            model: u.model,
            description: u.nameEng || '',
          }));

        setRelatedUnits(mapped);
        setEditOpen(true);
      } catch (error) {
        console.error('Error loading related units:', error);
      } finally {
        setEditLoading(false);
      }
    };
    loadEditData();
  };

  const searchInputRef = useRef<HTMLInputElement | null>(null);


  return (
    <React.Fragment>
      <Sheet
        className="SearchAndFilters-mobile"
        sx={{ display: { xs: 'flex', sm: 'none' }, my: 1, gap: 1 }}
      >
        <Input
          size="sm"
          placeholder="Search"
          startDecorator={<SearchIcon />}
          // value={search}
          // onChange={(e) => setSearch(e.target.value)}
          slotProps={{
            input: {
              ref: searchInputRef,
            },
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              const value = (e.target as HTMLInputElement).value;
              handleSearch(value); // Trigger search when Enter is pressed
            }
          }}
          sx={{ flexGrow: 1,maxWidth: '200px' }}
        />
        <IconButton
          size="sm"
          variant="outlined"
          color="neutral"
          onClick={() => {
            if (searchInputRef.current) {
              //console.log(searchInputRef.current); // Log the input element to check if it's correct
              const value = searchInputRef.current.value; // 获取输入框的值
              //console.log(value);
              handleSearch(value); // 调用搜索函数
            }
          }}
        >
          <FilterAltIcon />
        </IconButton>
      </Sheet>
      <Box
        className="SearchAndFilters-tabletUp"
        sx={{
          borderRadius: 'sm',
          py: 2,
          display: { xs: 'none', sm: 'flex' },
          flexWrap: 'wrap',
          gap: 1.5,
          maxWidth: '250px',
          '& > *': {
            minWidth: { xs: '120px', md: '160px' },
          },
        }}
      >
        <FormControl sx={{ flex: 1 }} size="sm">
          <Input 
            size="sm" 
            placeholder="Search" 
            startDecorator={<SearchIcon />} 
            // value={search}
            // onChange={(e) => setSearch(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                const value = (e.target as HTMLInputElement).value;
                handleSearch(value); // Trigger search when Enter is pressed
              }
            }}
          />
        </FormControl>
        {/* {renderFilters()} */}
      </Box>
      <Sheet
        className="PartTableContainer"
        variant="outlined"
        sx={{
          display: { xs: 'flex', sm: 'initial' },
          width: '100%',
          borderRadius: 'sm',
          flexShrink: 1,
          overflow: 'auto',
          minHeight: 0,
        }}
      >
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '70vh' }}>
            <CircularProgress />
          </Box>
        ) : (
        <Table
          aria-labelledby="tableTitle"
          stickyHeader
          hoverRow
          sx={{
            '--TableCell-headBackground': 'var(--joy-palette-background-level1)',
            '--Table-headerUnderlineThickness': '1px',
            '--TableRow-hoverBackground': 'var(--joy-palette-background-level1)',
            '--TableCell-paddingY': '4px',
            '--TableCell-paddingX': '8px',
          }}
        >
          <thead>
            <tr>
              <th style={{ width: 120, padding: '12px 6px' }}>
                <Link
                  underline="none"
                  color="primary"
                  component="button"
                  onClick={() => setOrder(order === 'asc' ? 'desc' : 'asc')}
                  endDecorator={<ArrowDropDownIcon />}
                  sx={[
                    {
                      fontWeight: 'lg',
                      '& svg': {
                        transition: '0.2s',
                        transform:
                          order === 'desc' ? 'rotate(0deg)' : 'rotate(180deg)',
                      },
                    },
                    order === 'desc'
                      ? { '& svg': { transform: 'rotate(0deg)' } }
                      : { '& svg': { transform: 'rotate(180deg)' } },
                  ]}
                >
                  Part Number
                </Link>
              </th>
              <th style={{ width: 140, padding: '12px 6px' }}>New Number</th>
              <th style={{ width: 180, padding: '12px 6px' }}>Name</th>
              {/* <th style={{ width: 240, padding: '12px 6px' }}>Description</th> */}
              <th style={{ width: 80, padding: '12px 6px' }}>List Price</th>
              <th style={{ width: 140, padding: '12px 6px' }}> </th>
            </tr>
          </thead>
          <tbody>
            {parts.sort((a, b) => a.number.localeCompare(b.number)).map((row) => (
              <tr key={row.id}>
                <td>
                  <Typography level="body-xs">{row.number}
                    {row.pic && (
                    <IconButton onClick={() => handleClickOpen(row.pic)} size="sm" color="primary">
                      <ZoomIn fontSize="small" />
                    </IconButton>
                  )}
                  </Typography>
                </td>
                <td>
                  <Typography level="body-xs">{row.number_new}</Typography>
                </td>
                <td>
                  <Typography level="body-xs">{row.name_eng}</Typography>
                </td>
                {/* <td>
                  <Typography level="body-xs">{row.description}</Typography>
                </td> */}
                <td>
                  <Typography level="body-xs">${(row.price_list ?? 0).toFixed(2)}</Typography>
                </td>
                <td>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                    <IconButton
                      size="sm"
                      variant="plain"
                      color="neutral"
                      onClick={() => handleEditClick(row)}
                      aria-label="Show related units"
                      sx={{ p: 0.5 }}
                    >
                      <MoreHorizIcon fontSize="small" />
                    </IconButton>
                  </Box>
                </td>
              </tr>
            ))}
          </tbody>

          {/* JoyUI Modal for displaying the image */}
      <Modal open={imageOpen} onClose={handleClose}>
        <Box
          sx={{

            position: 'fixed', // Position the modal in the center of the screen
            top: '50%', // Vertically center
                left: {
                  xs: '50%',
                  md: 'calc(50% + (var(--Sidebar-width, 0px) / 2))',
                }, // Center over right content on larger screens
            transform: 'translate(-50%, -50%)', 
            width: '100%',
            maxWidth: '600px',
            maxHeight: '100vh',
            overflow: 'auto',
            padding: 2,
            backgroundColor: 'white',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {imageSrc && (
            <img
              src={imageSrc}
              alt="Part Pic"
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain',
              }}
            />
          )}
        </Box>
      </Modal>
      {/* Loading Modal for Part Edit */}
      <Modal open={editLoading} onClose={() => {}} aria-labelledby="edit-loading-modal">
        <Box
          sx={{
            position: 'fixed',
            top: '50%',
            left: {
              xs: '50%',
              md: 'calc(50% + (var(--Sidebar-width, 0px) / 2))',
            },
            transform: 'translate(-50%, -50%)',
            width: '300px',
            padding: 3,
            backgroundColor: 'white',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <CircularProgress size="lg" />
          <Typography level="body-md">Loading part edit...</Typography>
        </Box>
      </Modal>

      <Modal open={editOpen} onClose={handleEditClose} aria-labelledby="edit-modal" aria-describedby="edit-modal-description">
      <Box
          sx={{

            position: 'fixed', // Position the modal in the center of the screen
            top: '50%', // Vertically center
            left: {
              xs: '50%',
              md: 'calc(50% + (var(--Sidebar-width, 0px) / 2))',
            }, // Center over right content on larger screens
            transform: 'translate(-50%, -50%)', 
            width: '100%',
            maxWidth: '600px',
            maxHeight: '100vh',
            overflow: 'auto',
            padding: 2,
            backgroundColor: 'white',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Typography level="h4" sx={{ mb: 1 }}>
            {currentPart} Related Units
          </Typography>
          <FormControl sx={{ mb: 1 }}>
            <FormLabel>Filter</FormLabel>
            <Input
              size="sm"
              placeholder="Search"
              value={relatedUnitFilter}
              onChange={(e) => setRelatedUnitFilter(e.target.value)}
            />
          </FormControl>
          <Sheet
            variant="outlined"
            sx={{ mt: 1, maxHeight: 400, overflow: 'auto' }}
          >
            <Table size="sm" stickyHeader>
              <thead>
                <tr>
                  <th style={{ width: 160, padding: '8px 6px' }}>Unit Number</th>
                  <th style={{ padding: '8px 6px' }}>Description</th>
                </tr>
              </thead>
              <tbody>
                {relatedUnits
                  .filter((u) => {
                    const q = relatedUnitFilter.trim().toLowerCase();
                    if (!q) return true;
                    return (
                      u.model.toLowerCase().includes(q) ||
                      u.description.toLowerCase().includes(q)
                    );
                  })
                  .map((u) => (
                    <tr key={u.id}>
                      <td>
                        <Typography level="body-xs">{u.model}</Typography>
                      </td>
                      <td>
                        <Typography level="body-xs">{u.description}</Typography>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </Sheet>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
            <Button size="sm" type="button" onClick={handleEditClose}>
              Close
            </Button>
          </Box>
        </Box>
        </Modal>
      <Modal open={orderOpen} onClose={handleOrderClose} aria-labelledby="order-model" aria-describedby="order-model-description">
        <Box
          sx={{
            position: 'fixed',
            top: '50%',
            left: {
              xs: '50%',
              md: 'calc(50% + (var(--Sidebar-width, 0px) / 2))',
            },
            transform: 'translate(-50%, -50%)',
            width: 400,
            boxShadow: 24,
            backgroundColor: 'white',
            maxWidth: '600px',
            maxHeight: '100vh',
            p: 4,
            borderRadius: 2,
          }}
        >
          <FormControl sx={{ width: '100%' }}>
            <Typography level="h4">{currentPart}</Typography>
            <Divider />
          </FormControl>

          {/* Quantity Input */}
          <FormControl sx={{ mb: 2 }}>
            <FormLabel>Quantity</FormLabel>
            <Input
              type="number"
              name="qty"
              value={poForm.qty}
              onChange={(e) => setPoForm((prevForm) => ({
                ...prevForm, // Keep the other fields in the state
                qty: Number(e.target.value), // Update only the qty field
              }))}
              style={{ width: '100%', marginBottom: '1rem' }}
            />
          </FormControl>

          {/* Branch Select */}
          <FormControl sx={{ mb: 2 }}>
            <FormLabel>Branch</FormLabel>
            <Select 
              name="branch"
              value={poForm.branch}
              onChange={(event, newValue) => handleChange(newValue)}
              required
              sx={{ minWidth: 200 }}
            >
              <option value="" disabled>Select a branch</option>
              {branches.map((item) => (
                <Option key={item.value} value={item.value}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </FormControl>

          {/* Action Buttons */}
          <div className="form-actions" style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
            <Button size="sm" type="button" onClick={handleOrderClose} style={{ padding: '0.5rem 1rem' }}>
              Cancel
            </Button>
            <Button size="sm" type="button" onClick={handleSubmit} style={{ padding: '0.5rem 1rem' }}>
              Submit
            </Button>
          </div>
        </Box>
      </Modal>


        </Table>
        )}
      </Sheet>
      
      {/* Mobile Pagination */}
      <Box
        className="Pagination-mobile"
        sx={{
          pt: 2,
          gap: 1,
          display: {
            xs: 'flex',
            md: 'none',
          },
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Button
          size="sm"
          variant="outlined"
          color="neutral"
          startDecorator={<KeyboardArrowLeftIcon />}
          onClick={() => handlePagination(currentPage - 1)}
          disabled={!prevPage}
        >
          Previous
        </Button>

        <Typography level="body-sm">
          Page {currentPage} of {totalPages}
        </Typography>

        <Button
          size="sm"
          variant="outlined"
          color="neutral"
          endDecorator={<KeyboardArrowRightIcon />}
          onClick={() => handlePagination(currentPage + 1)}
          disabled={!nextPage}
        >
          Next
        </Button>
      </Box>

      {/* Desktop Pagination */}
      <Box
        className="Pagination-laptopUp"
        sx={{
          pt: 2,
          gap: 1,
          [`& .${iconButtonClasses.root}`]: { borderRadius: '50%' },
          display: {
            xs: 'none',
            md: 'flex',
          },
        }}
      >
        <Button
          size="sm"
          variant="outlined"
          color="neutral"
          startDecorator={<KeyboardArrowLeftIcon />}
          onClick={() => handlePagination(currentPage - 1)}
          disabled={!prevPage}
        >
          Previous
        </Button>

        <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
          {/* Dynamically render page numbers with ellipsis */}
          {totalPages > 0 ? (
            <>
              {currentPage > 3 && (
                <IconButton
                  size="sm"
                  variant="outlined"
                  onClick={() => handlePagination(1)}
                  color="neutral"
                >
                  1
                </IconButton>
              )}

              {currentPage > 3 && <Typography sx={{ mx: 1 }}>...</Typography>}

              {getPaginationRange().map((pageNumber) => (
                <IconButton
                  key={pageNumber}
                  size="sm"
                  variant={pageNumber === currentPage ? 'solid' : 'outlined'}
                  onClick={() => handlePagination(pageNumber)}
                  color="neutral"
                >
                  {pageNumber}
                </IconButton>
              ))}

              {currentPage < totalPages - 2 && <Typography sx={{ mx: 1 }}>...</Typography>}

              {currentPage < totalPages - 2 && (
                <IconButton
                  size="sm"
                  variant="outlined"
                  onClick={() => handlePagination(totalPages)}
                  color="neutral"
                >
                  {totalPages}
                </IconButton>
              )}
            </>
          ) : (
            <Typography>No result</Typography>
          )}
        </Box>

        <Button
          size="sm"
          variant="outlined"
          color="neutral"
          endDecorator={<KeyboardArrowRightIcon />}
          onClick={() => handlePagination(currentPage + 1)}
          disabled={!nextPage}
        >
          Next
        </Button>
      </Box>
    </React.Fragment>
  );
}